/* eslint-disable */
import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import { api } from '@/utils/api';
import onboardingActions from './onboarding.actions';
import { OnboardingActionTypes } from './onboarding.types';
import logger from '@/utils/logger';
import { ONBOARDING_REGISTER_URL, WIZARD_REGISTER_URL } from '@/config/api';
import { COUNTRY } from '@/config';
import { ATIVACAO_UPDATE_ONBOARDING_FLOW_EVERY_STEP_CHANGE } from '@/config/GrowthBook/constants';

function* registerOnboarding(action) {
  const { token } = yield select(state => state.auth);
  const { hostingId, domain, origin, skip } = action.payload;

  const request = {
    url: ONBOARDING_REGISTER_URL(hostingId),
    headers: {
      Authorization: `Bearer ${token}`,
      'x-brand': COUNTRY,
    },
    data: { domain, origin, skip },
  };


  try {
    const response =  yield call(api.whmcs.post, request);
    const builderId = response.data.data.id;
    yield put(onboardingActions.onboarding.register.success({ builderId }));
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    logger.error('Error sagas onboarding - method registerOnboarding', error);
    yield put(onboardingActions.onboarding.register.failure());
  }
};

function* updateOnboarding(action) {
  const { token } = yield select(state => state.auth);
  const { hostingId, domain, origin, builder, finished, step } = action.payload;

  const request = {
    url: ONBOARDING_REGISTER_URL(hostingId),
    headers: {
      Authorization: `Bearer ${token}`,
      'x-brand': COUNTRY,
    },
    data: { domain, origin, builder, finished, step },
  };

  try {
    yield call(api.whmcs.patch, request);
    yield put(onboardingActions.onboarding.update.success());
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    logger.error('Error sagas onboarding - method registerOnboarding', error);
    yield put(onboardingActions.onboarding.update.failure());
  }
}

function* registerWizard(action) {
  const { token } = yield select(state => state.auth);
  const { domain, origin } = action.payload;

  const request = {
    url: WIZARD_REGISTER_URL(),
    headers: {
      Authorization: `Bearer ${token}`,
      'x-brand': COUNTRY,
    },
    data: { domain, origin },
  };

  try {
    const response = yield call(api.whmcs.post, request);
    yield put(onboardingActions.wizard.register.set({ wizardId: response.data.data.id }));
    yield put(onboardingActions.wizard.register.success());
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    logger.error('Error sagas onboarding - method registerOnboarding', error);
    yield put(onboardingActions.wizard.register.failure());
  }
};

function* updateWizard(action) {
  const { token } = yield select(state => state.auth);
  const { wizard } = yield select(state => state.newOnboarding);
  const commonReducer = yield select(state => state.common);
  const { domain, origin, builder, finished } = action.payload;
    const preventChangeStart = commonReducer && commonReducer.toggles[ATIVACAO_UPDATE_ONBOARDING_FLOW_EVERY_STEP_CHANGE]

  const request = {
    url: WIZARD_REGISTER_URL(wizard.id),
    headers: {
      Authorization: `Bearer ${token}`,
      'x-brand': COUNTRY,
    },
    data: { domain, origin, builder, finished },
  };

  try {
    yield call(api.whmcs.patch, request);
    yield put(onboardingActions.wizard.update.success(preventChangeStart));
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    logger.error('Error sagas onboarding - method registerOnboarding', error);
    yield put(onboardingActions.wizard.update.failure());
  }
}

function* sagas() {
  yield takeLatest(OnboardingActionTypes.ONBOARDING_REGISTER_REQUEST, registerOnboarding);
  yield takeLatest(OnboardingActionTypes.ONBOARDING_UPDATE_REQUEST, updateOnboarding);
  yield takeLatest(OnboardingActionTypes.WIZARD_REGISTER_REQUEST, registerWizard);
  yield takeLatest(OnboardingActionTypes.WIZARD_UPDATE_REQUEST, updateWizard);
}

export default sagas;
